<script lang="ts">
    
    import { fly } from "svelte/transition";
    import { onDestroy } from "svelte";
    import type { Game } from "../../Model/Game";
    import { SubscriptionsManager } from "../../Model/SubscriptionsManager";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";
    import GameCard from "./GameCard.svelte";
    import PlayIcon from "../Shared/Icons/PlayIcon.svelte";
    import MusicPlayer from "../Manager/MusicPlayer.svelte";
    import PauseIcon from "../Shared/Icons/PauseIcon.svelte";
    import { playingMusic, realTimeService } from "../../Services";

    export let game: Game;
    export let tail: number = 2;
    export let actualNumber: number;

    const gameSubscriptions = new SubscriptionsManager();
    const gameEventsChannel = game.getEventsChannel();

    const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

    let lastNumbers: number[] = [];
    let lastNumber: number;

    let playing: boolean = false;

    let numberPlaying: number;

    let src: string;

    $: setupGame(game);
    $: actualNumber ? initMusic(actualNumber) : undefined;
    $: lastNumber = lastNumbers.length > 0 ? lastNumbers[0] : 0;

    onDestroy(() => gameSubscriptions.unsubscribeAll());

    function setupGame(game: Game): void {
        gameEventsChannel.on('playing_music', onPlayingMusic)
        gameSubscriptions.unsubscribeAll();
        if (!game) {
            lastNumbers = [];
            return;
        }
        gameSubscriptions.subscribe(game.numbers, numbers => {
            lastNumbers = numbers.slice(-(tail + 1)).reverse();

            numberPlaying = numbers[numbers.length - 1];
            lastNumber = numbers[numbers.length - 1];

        });
    }

    function initMusic(number: number) {
        numberPlaying = number;

        if(playing) {

            realTimeService.send('playing_music', { 
                playing: false,
                gameId: game.id
            });
            src = undefined;

            delay(500).then(() => playMusic(number)) 
            return;
        }

        src = `/music/${game.type}/${number}.mp3`;

        realTimeService.send('playing_music', { 
            playing: true,
            gameId: game.id
        });
    }

    function playMusic(number: number):void {
        if(number != lastNumber) return;

        numberPlaying = number;

        if(playing) {
            realTimeService.send('playing_music', { 
                playing: false,
                gameId: game.id
            });

            src = undefined;

            return;
        }

        src = `/music/${game.type}/${number}.mp3`;

        realTimeService.send('playing_music', { 
            playing: true,
            gameId: game.id
        });
    }

    function onMusicEnded() {

        realTimeService.send('playing_music', { 
            playing: false,
            gameId: game.id
        });

        numberPlaying = undefined;
        src = '';
    }

    function onPlayingMusic({ data }: any) {
        playing = data.playing;
    }
</script>

{#if playing}
    <MusicPlayer 
        bind:src
        on:ended={onMusicEnded}
    />
{/if}

<AspectKeeper ratio={1.4}>
    <div class="game-historic font-bingo-number" style="--tail: {1 / tail};">
        {#each lastNumbers as number (number)}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div on:click={() => playMusic(number)} class="number {number == lastNumber ? 'cursor' : ''}" in:fly={{ y: -100 }} out:fly={{ y: 100 }}>
                {#if number == lastNumber}
                    <!-- <button on:click={() => playMusic(number)} class='play'> -->
                        {#if playing}
                            <span class='play'><PauseIcon /></span>
                        {:else}
                            <span class='play'><PlayIcon /></span>
                        {/if}
                    <!-- </button> -->
                {/if}
                <GameCard {number} gameType={game.type} />
            </div>
        {/each}
    </div>
</AspectKeeper>

<style lang="scss">
    .play {
        position: absolute;
        z-index: 50;
        padding: 2rem;
        width: calc(3vw + 3vh);
        height: calc(3vw + 3vh);
        border-radius: 40%;
        display: grid;
        place-content: center;
        object-fit: contain;
        color: #fff;
    }

    .game-historic {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .number {
        position: absolute;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.3s;
        background-color: transparent;
        border: none;

        :global(img) {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .number:nth-child(1) {
        height: 70%;
        top: 0;
        z-index: 5;
    }

    @for $i from 2 through 4 {
        .number:nth-child(#{$i}) {
            height: 30%;
            top: 70%;
            width: calc(100% * var(--tail));
            left: calc(100% * var(--tail) * #{$i - 2});
        }
    }

    .number:nth-child(5) {
        height: 30%;
        top: 70%;
        width: 33.33%;
        left: 66.66%;
    }
    
    .cursor {
        cursor: pointer;
    }

</style>
